export default __webpack_public_path__ + "static/media/Billing_Transaction_subscribe.01b0b7de.svg";